import React from 'react';
import { useSelector } from 'react-redux';

const NavigationButtons = () => {
    const { brandCampaignCreationStep } = useSelector(state => state.utilReducers);
    
    const sections = [
        "Basic Details",
        "Campaign Content Details",
        "Audience & Demographic Details",
        "Campaign Targets and Budget"
    ];
    
    // Get current section based on the step
    const currentSection = sections[brandCampaignCreationStep - 1] || sections[0];
    
    return (
        <div className="flex flex-col justify-start items-center md:flex-row h-auto md:h-[12rem] py-6">
            {/* Mobile view - only show current section */}
            <div className="md:hidden w-full py-4">
                <div 
                    className="text-[1.4rem] inter-font font-[500] text-center py-4 px-8 rounded-[1rem] 
                        text-[#0D9B50] bg-[#DBEAE6] cursor-default w-full"
                >
                    {currentSection}
                </div>
            </div>
            
            {/* Desktop view - show all sections */}
            <div className="hidden md:flex md:flex-row w-full py-4 items-center">
                {sections.map((item, index) => (
                    <React.Fragment key={index}>
                        <div
                            className={`text-[1.4rem] inter-font font-[500] text-center py-4 px-16 rounded-[1rem]
                                ${index+1 <= brandCampaignCreationStep ? 'text-[#0D9B50] bg-[#DBEAE6]' : 'bg-[#E3E5E9] text-[#38414A]'}
                                cursor-default`
                            }
                            // onClick={() => dispatch(setBrandCampaignCreationStep(index+1))}
                            // disabled={index+1 > brandCampaignCreationStep}
                        >
                            {item}
                        </div>
                        {index < sections.length - 1 && (
                            <div className="border border-[#C5C6C8] w-[4rem] h-[0.1rem] mx-2"></div>
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default NavigationButtons;